import React from 'react'

const NewResultHeading = () => {
  return (
    <>
    <div className="hidden lg:flex items-center justify-between gap-2.5">
        <h2 className='text-[#e9ebec] text-[30px] font-bold font-KoreanTITGD'>베팅내역</h2>
        <button className='bg-[#303540] text-[#9399a1] text-sm font-bold h-[46px] px-4 transition-all duration-300 hover:filter hover:brightness-[0.95] font-KoreanTITGD'>전체삭제</button>
    </div>
    
    </>
  )
}

export default NewResultHeading